import React from "react";
import { FiArrowRight, FiCheck, FiMail, FiPackage, FiTruck } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";
import PageMeta from "./PageMeta";
import "../css/paysuccess.css";

const orderSteps = [
  {
    icon: FiMail,
    title: "Confirmation",
    copy: "A receipt and order summary will be sent to the contact used at checkout.",
  },
  {
    icon: FiPackage,
    title: "Careful packing",
    copy: "Our team will prepare your selection and protect every chilled item for its journey.",
  },
  {
    icon: FiTruck,
    title: "Delivery update",
    copy: "We will let you know when the order leaves us and is on its way to your table.",
  },
];

function PaySuccess() {
  const { state } = useLocation();

  return (
    <main className="payment-success-page">
      <PageMeta
        title="Order confirmed"
        description={`Your ${siteConfig.brandName} order has been received.`}
      />

      <section className="payment-success" aria-labelledby="success-title">
        <div className="payment-success__shell">
          <div className="payment-success__card">
            <div className="payment-success__mark" aria-hidden="true">
              <FiCheck />
            </div>
            <p className="payment-success__eyebrow">Order confirmed</p>
            <h1 id="success-title">Thank you—your order is in.</h1>
            <p className="payment-success__lead">
              We have received your order and will begin preparing it shortly.
              Keep an eye on your inbox for the full confirmation.
            </p>

            {state?.orderNumber && (
              <dl className="payment-success__order-meta">
                <div><dt>Order</dt><dd>{state.orderNumber}</dd></div>
                <div><dt>Total</dt><dd>{formatPrice(state.total)}</dd></div>
                <div><dt>Confirmation</dt><dd>{state.email}</dd></div>
              </dl>
            )}

            <div className="payment-success__status" role="status">
              <span>Order status</span>
              <strong><i aria-hidden="true" /> Confirmed</strong>
            </div>

            <div className="payment-success__steps" aria-label="What happens next">
              {orderSteps.map(({ icon: Icon, title, copy }, index) => (
                <article key={title}>
                  <div className="payment-success__step-icon">
                    <Icon aria-hidden="true" />
                    <span>{index + 1}</span>
                  </div>
                  <div>
                    <h2>{title}</h2>
                    <p>{copy}</p>
                  </div>
                </article>
              ))}
            </div>

            <div className="payment-success__note">
              <strong>{siteConfig.delivery.promise}.</strong>
              <span>Actual timing is confirmed in your delivery update.</span>
            </div>

            <div className="payment-success__actions">
              <Link className="payment-success__primary" to="/shop">
                Continue shopping <FiArrowRight aria-hidden="true" />
              </Link>
              <Link className="payment-success__secondary" to="/contact">
                Need help with this order?
              </Link>
            </div>
          </div>

          <p className="payment-success__support">
            Questions? Email{" "}
            <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
          </p>
        </div>
      </section>
    </main>
  );
}

export default PaySuccess;
